import types from './types';
import actions from './actions';

export default {
  types,
  actions,
};



// WEBPACK FOOTER //
// ./src/api/products/index.js